import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Form from "../../comman/form";
import config from "../../config.json";
import http from "../../services/HttpService";
import Joi from "joi-browser";
import ThankYou from "./ThankYou";

class ContactAdmin extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      errors: {},
      userTypes: [
        {
          id: 1,
          name: "Health Care Practitioners (HCP)",
        },
        {
          id: 2,
          name: "Caregivers",
        },
        {
          id: 3,
          name: "PLGS",
        },
        {
          id: 4,
          name: "Pharmacists",
        },
        {
          id: 5,
          name: "Manufacturers",
        },
        {
          id: 6,
          name: "Distributors",
        },
        {
          id: 7,
          name: "Labs",
        },
        {
          id: 8,
          name: "Patient",
        },
      ],
      contactMain: true,
      thankYou: false,
    };
  }

  schema = {
    firstName: Joi.string().required().label("First Name"),
    lastName: Joi.string().required().label("Last Name"),
    email: Joi.string().email().required().label("Email"),
    //userType: Joi.string().required().label("User Type"),
    captcha: Joi.string().required().label("Captcha"),
  };

  onCaptchaChange = (value) => {
    const { data } = this.state;
    data["captcha"] = value;
    this.setState({ data });
  };

  doSubmit = async () => {
    const { data } = this.state;
    const { data: result } = await http.post(config.ContactAdmin, data);
    console.log(result);
    if (result !== "fail") {
      this.setState({ contactMain: false, thankYou: true });
    }
  };

  render() {
    const { userTypes, contactMain, thankYou } = this.state;
    const { handleContactBack } = this.props;
    return (
      <React.Fragment>
        {contactMain && (
          <div className="row">
            <div className="col-md-12">
              <button
                className="btn btn-link pl-0 btn-sm"
                onClick={handleContactBack}
              >
                <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                Back
              </button>
            </div>
            {/* <div className="col-md-12">
              {this.renderSelect(
                "userType",
                "Identify Yourself",
                userTypes,
                "name",
                "name"
              )}
            </div> */}
            <div className="col-md-12">
              {this.renderInput("firstName", "First Name")}
            </div>
            <div className="col-md-12">
              {this.renderInput("lastName", "Last Name")}
            </div>
            <div className="col-md-12">
              {this.renderInput("email", "Registered Email")}
            </div>
            <div className="col-md-12 form-group">
              <ReCAPTCHA
                sitekey="6Le08xsUAAAAAKC6Oglhe-haRVGzA8KTLUZ-jmEK"
                onChange={this.onCaptchaChange}
              />
            </div>
            <div className="col-md-12">
              <button
                className="btn btn-outline-default w-100"
                style={{ backgroundColor: "#298607", color: "white" }}
                onClick={this.handleSubmit}
                disabled={this.validate()}
              >
                SUBMIT
              </button>
            </div>
          </div>
        )}
        {thankYou && <ThankYou></ThankYou>}
      </React.Fragment>
    );
  }
}

export default ContactAdmin;
